import {DatePicker} from "manager/views/components/ReferralStatus/SingleDatePicker"
import styled from "styled-components"
import React from "react"

const DatePickerWrapper = ({className, value, onChange, errorMsg}) => (
    <div className={className}>
      <DatePicker useNative
                  value={value}
                  onChange={onChange}
                  orientation="vertical"
                  futureDatesOnly
                  errorMsg={errorMsg}/>
    </div>
)

const SettlementDatePicker = styled(DatePickerWrapper)`
    .OP_SingleDatePicker {
      flex-grow: 1;
    
      label {
        display: none;
      }
      
      .OP_SingleDatePicker__error {
        margin-bottom: 0px;
      }
      
      input,
      .SingleDatePickerInput {
        width: 100%;
        height: 100%;
        border: 1px solid #CCCCCC;
        border-radius: 4px;
        font-size: 14px;
        line-height: 18px;
        padding-top: 12.5px;
        padding-bottom: 11.5px;
        padding-left: 11.5px;
        -webkit-appearance: inherit !important;
        -moz-appearance: textfield;
        min-height: 3.25em;
        
        &:focus {
          outline: none;
        }
      }
    }
`

export default SettlementDatePicker
